import type { JSX } from 'react'

import { ButtonCorners, ButtonFonts } from 'atoms/Button/Button.h'
import {
  CancelSecondaryOpacityButton,
  PrimaryButton,
} from 'atoms/Button/Templates'
import { TextAligning } from 'atoms/TextBox'
import {
  TextBoxMaxLine2FontSm,
  TextBoxMaxLine2FontXlBold,
} from 'atoms/TextBox/Templates'
import { Colors } from 'atoms/TextBox/TextBox.h'
import {
  BodySC,
  ButtonsSC,
  OverlaySC,
  UpgradeCurrentPackageSC,
} from './UpgradeCurrentPackage.styled'

export interface IUpgradeCurrentPackageProps {
  title: string
  description: string
  updateButtonText: string
  cancelButtonText: string
  onUpgrade: () => void
  onCancel: () => void
  isLoading: boolean
}

export const UpgradeCurrentPackage = ({
  title,
  description,
  updateButtonText,
  cancelButtonText,
  onUpgrade,
  onCancel,
  isLoading,
}: IUpgradeCurrentPackageProps): JSX.Element => (
  <OverlaySC>
    <UpgradeCurrentPackageSC>
      <BodySC>
        <TextBoxMaxLine2FontXlBold
          title={title}
          alignment={TextAligning.Center}
        />
        <TextBoxMaxLine2FontSm
          title={description}
          alignment={TextAligning.Center}
          color={Colors.TEXT_ICON_SECONDARY}
        />
      </BodySC>

      <ButtonsSC>
        <PrimaryButton
          title={updateButtonText}
          onClick={onUpgrade}
          corners={ButtonCorners.CORNERS_10}
          font={ButtonFonts.FontSmBold}
          withLoader
          hideTitleOnLoading
          isLoading={isLoading}
          disabled={isLoading}
        />
        <CancelSecondaryOpacityButton
          title={cancelButtonText}
          onClick={onCancel}
          corners={ButtonCorners.CORNERS_10}
          font={ButtonFonts.FontSmBold}
        />
      </ButtonsSC>
    </UpgradeCurrentPackageSC>
  </OverlaySC>
)
